import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-view-help',
    templateUrl: './view-help.component.html',
    styleUrls: ['./view-help.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ViewHelpComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
